import React from "react";
import { ImageBackground, StyleSheet, View, ViewStyle } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Footer } from "./Footer";

type Props = {
  children: React.ReactNode;
  backgroundImage?: any; // require(...) OR { uri: "" }
  overlayOpacity?: number; // 0..1
  overlayColor?: string; // hex/rgba
  style?: ViewStyle;
};

const FOOTER_H = 30; // approximate footer visible height (text + padding)

export function DivineBackground({
  children,
  backgroundImage = require("../../../assets/background.jpg"),
  overlayOpacity = 0.9,
  overlayColor = "#617EA4",
  style,
}: Props) {
  const insets = useSafeAreaInsets();

  // ✅ Reserve space so content never goes behind footer / system nav bar
  const reservedBottom = FOOTER_H + Math.max(insets.bottom, 10);

  return (
    <View style={[styles.root, style]}>
      <ImageBackground source={backgroundImage} resizeMode="cover" style={styles.bg}>
        {/* Color overlay */}
        <View
          style={[
            StyleSheet.absoluteFill,
            { backgroundColor: overlayColor, opacity: overlayOpacity },
          ]}
        />

        {/* subtle top→bottom gradient like figma */}
        <LinearGradient
          colors={[
            "rgba(255,248,231,0.10)",
            "rgba(255,248,231,0.00)",
            "rgba(255,200,120,0.12)",
          ]}
          style={StyleSheet.absoluteFill}
        />

        {/* ✅ Content safe area for footer */}
        <View style={[styles.content, { paddingBottom: reservedBottom }]}>
          {children}
        </View>

        {/* ✅ Footer pinned above system navigation bar */}
        <View style={[styles.footerWrap, { paddingBottom: Math.max(insets.bottom, 6) }]}>
          <Footer />
        </View>
      </ImageBackground>
    </View>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1, backgroundColor: "#FFF8E7" },
  bg: { flex: 1 },
  content: { flex: 1 },
  footerWrap: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
  },
});
  